import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'

interface Props {
  label: string
  color: string
  textColor: string
}

const ChartTag = ({ color, label, textColor }: Props) => {
  return (
    <Container color={color}>
      <Point color={textColor} />
      <Label color={textColor}>{label}</Label>
    </Container>
  )
}

export default ChartTag

const Container = styled(View)<{ color: string }>`
  flex-direction: row;
  align-items: center;
  border-radius: 36px;
  padding: ${(props) => (props.theme.breakpoint === 'phone' ? 5 : 10)}px;
  background-color: ${(props) => props.color};
`

const Point = styled(View)<{ color: string }>`
  height: ${(props) => (props.theme.breakpoint === 'phone' ? 8 : 16)}px;
  width: ${(props) => (props.theme.breakpoint === 'phone' ? 8 : 16)}px;
  border-radius: 16px;
  margin-right: 4px;
  background-color: ${(props) => props.color};
`

const Label = styled(Text)<{ color: string }>`
  ${(props) => (props.theme.breakpoint === 'phone' ? props.theme.fonts.Caption2 : props.theme.fonts.Option)};
  color: ${(props) => props.color};
`
